import { render, staticRenderFns } from "./Promo.vue?vue&type=template&id=bab5bb98&"
import script from "./Promo.vue?vue&type=script&lang=js&"
export * from "./Promo.vue?vue&type=script&lang=js&"
import style0 from "./Promo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bab5bb98')) {
      api.createRecord('bab5bb98', component.options)
    } else {
      api.reload('bab5bb98', component.options)
    }
    module.hot.accept("./Promo.vue?vue&type=template&id=bab5bb98&", function () {
      api.rerender('bab5bb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Promo.vue"
export default component.exports